import { useAppSelector } from "@redux/hooks";
import { useEffect } from "react";
import { useToast } from "@shared-kernel/primary/shared/shadcn/ui/use-toast";
import { useNavigate } from "react-router-dom";
import { selectAccountActivation } from "@user-management-context/write/application/use-cases/account-activation/selectors/account-activation-selectors";

export const useAccountActivation = () => {
  const navigate = useNavigate();
  const { toast } = useToast();
  const { processing } = useAppSelector(selectAccountActivation);

  useEffect(() => {
    if (processing === "success") {
      navigate("/login");
      toast({ description: "Votre compte a été activé !" });
    } else if (processing === "failed") {
      toast({ description: "Erreur lors de l'activation de votre compte", variant: "destructive" });
    }
  }, [processing, navigate, toast]);
};
